import React from 'react';

import {
  Control,
  FieldPath,
  FieldValues,
  useWatch
} from 'react-hook-form';
import {
  Box,
  Paper,
  styled
} from '@mui/material';

import { fields } from 'iron-forge-react-modules';
import { Tag as MuiTag } from '@mui/icons-material';



const RootBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

const Tag = styled(MuiTag)({
  fontSize: '16px',
  color: 'rgba(160, 160, 160, 1)'
});

const ColorPreviewBox = styled(Paper)<{ color: string; }>(({ color }) => ({
  width: 32,
  height: 32,
  backgroundColor: `#${color || 'ffffff'}`,
  borderRadius: 16
}));

export interface IProps<TFormState extends FieldValues> {
  fieldKey: FieldPath<TFormState>;
  label: string;
  formControl: Control<TFormState>;
  isRequired?: boolean;
  isDisabled?: boolean;
}

export function genControllerComponent<T extends FieldValues>() {
  const ControlledTextField = fields.TextField.genControllerComponent<T>();

  const ColorPickerController: React.FC<IProps<T>> = props => {
    const currentValue = useWatch({
      name: props.fieldKey,
      control: props.formControl
    });
    return (
      <RootBox>
        <ControlledTextField
          isDisabled={props.isDisabled}
          isRequired={props.isRequired}
          disableDefaultMargins
          size="small"
          label={props.label}
          formControl={props.formControl}
          fieldKey={props.fieldKey}
          extraValidationRules={{
            pattern: /[a-fA-F0-9]{6}/
          }}
          startAdornment={(
            <Tag />
          )} />

        <ColorPreviewBox color={currentValue} />
      </RootBox>
    );
  };

  return ColorPickerController;
}
